module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "ou2tkg2q",
    dataset: process.env.GATSBY_SANITY_DATASET || "production",
  },
  auth: false,
};
